import BaseModal from "../../../../components/ui/BaseModal";
import BaseTextField from "../../../../components/ui/BaseTextField";
import BaseButton from "../../../../components/ui/BaseButton";
import { useFormik } from "formik";
import * as yup from "yup";
import { useMutation } from "@tanstack/react-query";
import { updateCompanyUser } from "../../../../services/api/company";
import { useDispatch } from "react-redux";
import { showToast } from "../../../../store/toast/toastSlice";
import SearchLocation from "../../../../components/SearchLocation/SearchLocation";
import BaseAutoSelect from "../../../../components/ui/BaseAutoSelect";
import {
  createDesignation,
  updateDesignation,
} from "../../../../services/api/designation";
const getValidationSchema = (isEdit) =>
  yup.object({
    designation: yup.string("").required("Enter Role name"),
    description: yup.string(""),
  });

const AddEditRoleModal = ({
  open,
  close,

  selectedDesignation,
  setSelectedDesignation,
  refetchAllCompanyDesignations,
}) => {
  const dispatch = useDispatch();
  const {
    isPending: isNewCreatedUserApiLoading,
    error: isNewCreatedUserApiError,
    data: newCreatedUser,
    mutateAsync: createDesignationMutation,
  } = useMutation({
    mutationFn: createDesignation,
    enabled: false,
  });

  const {
    isPending: isUpdateDesignationApiLoading,
    error: isUpdateDesignationApiError,
    data: updatedUser,
    mutateAsync: updateDesignationMutation,
  } = useMutation({
    mutationFn: updateDesignation,
    enabled: false,
  });

  const formik = useFormik({
    initialValues: {
      designation: selectedDesignation?.designation,
      description: selectedDesignation?.description,
    },
    validationSchema: getValidationSchema(!!selectedDesignation),
    onSubmit: (values) => {
      handleSubmitButton();
    },
    validateOnChange: true,
    validateOnBlur: true,
    enableReinitialize: true,
  });

  const handleSubmitButton = () => {
    if (selectedDesignation) {
      editDesignation();
    } else {
      createNewDesignation();
    }
  };

  const createNewDesignation = async () => {
    try {
      const newDesignation = await createDesignationMutation(formik.values);
      refetchAllCompanyDesignations();
      dispatch(
        showToast({
          message: "Designation created successfully",
          type: "success",
        })
      );
      close(false);
    } catch (error) {
      dispatch(
        showToast({
          message: error?.response?.data?.message,
          type: "success",
        })
      );
    }
  };

  const editDesignation = async () => {
    try {
      const payload = {
        id: selectedDesignation?.id,
        ...formik.values,
      };
      const updatedDesignation = await updateDesignationMutation(payload);
      refetchAllCompanyDesignations();
      dispatch(
        showToast({
          message: "desgination updated successfully",
          type: "success",
        })
      );
      close(false);
    } catch (error) {
      dispatch(
        showToast({
          message: error?.response?.data?.message,
          type: "success",
        })
      );
    }
  };

  return (
    <form>
      <BaseModal
        open={open}
        close={() => {
          close(false);
          setSelectedDesignation(null);
        }}
        className="-top-[200px] overflow-auto"
        style={{ width: "1000px" }}
      >
        <div className="px-8 py-5">
          <h6 className="text-dark font-medium border-b pb-1">
            {selectedDesignation ? "Update Role" : "Create New Role"}
          </h6>
        </div>
        <div className="px-8 py-4 grid grid-cols-2 gap-x-6 gap-y-4">
          <div className="col-span-2">
            <BaseTextField
              label="Desgination"
              labelShrink={false}
              optional={false}
              id="designation"
              name="designation"
              value={formik.values.designation}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.designation && Boolean(formik.errors.designation)
              }
              helperText={
                formik.touched.designation && formik.errors.designation
              }
            />
          </div>

          <div className="col-span-2">
            <BaseTextField
              labelShrink={false}
              label="Description"
              optional={false}
              required
              fullWidth
              id="description"
              name="description"
              value={formik.values.description}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.description && Boolean(formik.errors.description)
              }
              helperText={
                formik.touched.description && formik.errors.description
              }
            />
          </div>
        </div>

        <div
          className="d-flex content-center  bg-white py-6 mt-6"
          style={{
            boxShadow: "0px 0px 14px 0px rgba(0, 0, 0, 0.07)",
          }}
        >
          <BaseButton
            className=" px-[28px] py-[5px] text-primary hover:!text-white"
            variant="outlined"
            color="primary"
            style={{
              marginRight: "16px",
            }}
            onClick={() => {
              close(false);
              setSelectedDesignation(null);
            }}
          >
            Cancel
          </BaseButton>

          <BaseButton
            disabled={
              !formik.dirty ||
              !formik.isValid ||
              isNewCreatedUserApiLoading ||
              isUpdateDesignationApiLoading
            }
            loaderSize="22px"
            isLoading={
              isNewCreatedUserApiLoading || isUpdateDesignationApiLoading
            }
            color="primary"
            className="py-[5px] px-[20px] min-w-32"
            type="submit"
            onClick={formik.handleSubmit}
          >
            {selectedDesignation ? "Update" : "Create"}
          </BaseButton>
        </div>
      </BaseModal>
    </form>
  );
};

export default AddEditRoleModal;
